import { useQuery } from 'react-query';
import { Paginated } from '../../interfaces/Paginated';
import { ENTITY_DATA } from '../../constants/queryKeys';
import useAxiosInstance from '../useAxiosInstance';
import { Entity } from '../../interfaces/Entity';
import { SortDirection, SortState } from '@publicisgroupe/p-os-components';
import { mapConfigModelFieldNames } from '../../utils/mapConfigModelFieldNames';
import { FilterFieldsDto } from '../../models';
import { getByFilter } from '../../services/ConfigService/EntityService';

export default function useGetEntityByFilterQuery(
  entityName: string,
  filterData: FilterFieldsDto,
  itemsPerPage: number,
  continuationToken: string | undefined,
  sortState?: SortState<Entity, string>
) {
  const { axios } = useAxiosInstance();

  let url = `Entity/${entityName}/filtered?take=${itemsPerPage}`;
  if (continuationToken) {
    url += `&continuationToken=${encodeURIComponent(
      continuationToken
    ).toString()}`;
  }
  if (sortState?.name) {
    const orderBy = mapConfigModelFieldNames(sortState?.name);
    const orderAsc = sortState?.direction === SortDirection.Ascending;
    url +=
      `&orderBy=${encodeURIComponent(orderBy).trim().toString()}` +
      `&orderAsc=${orderAsc}`;
  }

  return useQuery<Paginated<Entity>>(
    [
      ENTITY_DATA,
      entityName,
      continuationToken,
      sortState?.name,
      sortState?.direction,
      filterData,
    ],
    async () => getByFilter(axios, url, filterData),
    { enabled: !!entityName }
  );
}
